<!--
# -----------------------------------------------------------------------------
# Component: CreateCreditNote.vue
# Author: antonio.ramirez@pst.sg
# Created Date: 14/May/2019
# Comments: Page for Create Credit Note Functionality
# -----------------------------------------------------------------------------
-->
<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-layout row wrap>
        <v-flex xs12>
          <v-card>
            <v-toolbar v-if="this.creditNoteData.tranMode !== 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-plus</v-icon>
              <v-toolbar-title>Create New Credit Note</v-toolbar-title>
            </v-toolbar>
            <v-toolbar v-if="this.creditNoteData.tranMode === 'R'" dense color="grey lighten-3" flat>
              <v-icon>mdi-pencil</v-icon>
              <v-toolbar-title>Edit Credit Note </v-toolbar-title>
            </v-toolbar>
            <v-tabs v-model="tabNav">
              <v-tab @click.native="doMandatory(0)">Mandatory</v-tab>
              <v-tab @click.native="doOptional(1)">Optional</v-tab>
            </v-tabs>
            <v-tabs-items v-model="tabNav" :reverse-transition="false" touchless>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="mandatory" eager>
                <form data-vv-scope="creditNoteMandatoryForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="branches"
                                v-model="creditNoteForm.branch"
                                :disabled="this.creditNoteData.tranMode === 'R'"
                                :label="creditNoteFormLabel.branch"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.branch"
                                :data-vv-as="creditNoteFormLabel.branch"
                                :error-messages="errors.collect('creditNoteForm.branch')"
                                clearable
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12 v-if="this.creditNoteData.tranMode !== 'R'">
                              <v-checkbox color="primary" :label="creditNoteFormLabel.docAE" v-model="creditNoteForm.docAE"></v-checkbox>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="creditNoteForm.documentNo"
                                :disabled="isDisableddocumentNo || this.creditNoteData.tranMode === 'R'"
                                :label="creditNoteFormLabel.documentNo"
                                :error-messages="errors.collect('creditNoteForm.documentNo')"
                                data-vv-name="creditNoteForm.documentNo"
                                :data-vv-as="creditNoteFormLabel.documentNo"
                                @blur="checkDocNo"
                                v-validate="docNoValidation"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <!--
                                <cal-picker v-model="creditNoteForm.transactionDate" :label="creditNoteFormLabel.transactionDate" :data-vv-as="creditNoteFormLabel.transactionDate" data-vv-name="creditNoteForm.transactionDate" :error-messages="errors.collect('creditNoteForm.transactionDate')" v-validate="tranDateValidation" :min="this.parseDateISO(this.tDateRange.effDate)" :max="this.parseDateISO(this.tDateRange.expDate)"></cal-picker>
                                -->
                              <cal-picker
                                v-model="creditNoteForm.transactionDate"
                                :label="creditNoteFormLabel.transactionDate"
                                :data-vv-as="creditNoteFormLabel.transactionDate"
                                data-vv-name="creditNoteForm.transactionDate"
                                :error-messages="errors.collect('creditNoteForm.transactionDate')"
                                v-validate="doValidateTranDate"
                                :loading="loading"
                              ></cal-picker>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="accounts"
                                v-model="creditNoteForm.accountNo"
                                item-text="label"
                                item-value="value"
                                :label="creditNoteFormLabel.accountNo"
                                :error-messages="errors.collect('creditNoteForm.accountNo')"
                                data-vv-name="creditNoteForm.accountNo"
                                :data-vv-as="creditNoteFormLabel.accountNo"
                                @change="getAcctInfo($event)"
                                v-validate="'required'"
                                clearable
                                :disabled="this.creditNoteData.tranMode === 'R'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon
                                    color="info"
                                    @click="showAcctNoHelpList = true"
                                    v-text="'mdi-magnify'"
                                    :disabled="this.creditNoteData.tranMode === 'R'"
                                  ></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="funds"
                                v-model="creditNoteForm.fund"
                                item-text="label"
                                item-value="value"
                                :label="creditNoteFormLabel.fund"
                                :error-messages="errors.collect('creditNoteForm.fund')"
                                data-vv-name="creditNoteForm.fund"
                                :data-vv-as="creditNoteFormLabel.fund"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showFundHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md5 xs12>
                              <v-autocomplete
                                :items="acctnosuffixes60"
                                v-model="creditNoteForm.accountNoSuffix"
                                item-text="label"
                                item-value="value"
                                :label="creditNoteFormLabel.accountNoSuffix"
                                :error-messages="errors.collect('creditNoteForm.accountNoSuffix')"
                                data-vv-name="creditNoteForm.accountNoSuffix"
                                :data-vv-as="creditNoteFormLabel.accountNoSuffix"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctSufHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-autocomplete
                                :items="gstIO"
                                v-model="creditNoteForm.gstIO"
                                :label="creditNoteFormLabel.gstIO"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstIO"
                                :data-vv-as="creditNoteFormLabel.gstIO"
                                :error-messages="errors.collect('gstIO')"
                                @change="changeGstIO($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md3 xs12>
                              <v-autocomplete
                                :items="gstStatuses"
                                v-model="creditNoteForm.gstStatus"
                                :label="creditNoteFormLabel.gstStatus"
                                item-text="label"
                                item-value="value"
                                data-vv-name="gstStatus"
                                :data-vv-as="creditNoteFormLabel.gstStatus"
                                :error-messages="errors.collect('gstStatus')"
                                :disabled="isBlankGSTIO"
                                @change="changeGstRate($event)"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md2 xs12>
                              <v-text-field
                                v-model="creditNoteForm.gstRate"
                                :label="creditNoteFormLabel.gstRate"
                                disabled
                                hide-details:error-messages="errors.collect('creditNoteForm.gstRate')"
                                data-vv-name="creditNoteForm.gstRate"
                                :data-vv-as="creditNoteFormLabel.gstRate"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="amountcurrencies"
                                v-model="creditNoteForm.amountCurr"
                                :label="creditNoteFormLabel.amountCurr"
                                item-text="label"
                                item-value="value"
                                :error-messages="errors.collect('creditNoteForm.amountCurr')"
                                data-vv-name="creditNoteForm.amountCurr"
                                :data-vv-as="creditNoteFormLabel.amountCurr"
                                v-validate="'required'"
                                clearable
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showCurrencyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-autocomplete>
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                ref="amount"
                                v-model="creditNoteForm.amount"
                                :label="creditNoteFormLabel.amount"
                                :error-messages="errors.collect('creditNoteForm.amount')"
                                data-vv-name="creditNoteForm.amount"
                                :data-vv-as="creditNoteFormLabel.amount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="creditNoteForm.gstAmountCurr"
                                :label="creditNoteFormLabel.gstAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.gstAmountCurr"
                                :data-vv-as="creditNoteFormLabel.gstAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.gstAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="creditNoteFormLabel.gstAmountAE"
                                :disabled="isGstAmtAE"
                                v-model="creditNoteForm.gstAmountAE"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="gstAmount"
                                v-model="creditNoteForm.gstAmount"
                                :label="creditNoteFormLabel.gstAmount"
                                :disabled="isGstAmt"
                                :error-messages="errors.collect('creditNoteForm.gstAmount')"
                                data-vv-name="creditNoteForm.gstAmount"
                                :data-vv-as="creditNoteFormLabel.gstAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-autocomplete
                                :items="currencies"
                                v-model="creditNoteForm.netAmountCurr"
                                :label="creditNoteFormLabel.netAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.netAmountCurr"
                                :data-vv-as="creditNoteFormLabel.netAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.netAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md8 xs12>
                              <v-text-field
                                v-model="creditNoteForm.netAmount"
                                :label="creditNoteFormLabel.netAmount"
                                disabled
                                :error-messages="errors.collect('creditNoteForm.netAmount')"
                                data-vv-name="creditNoteForm.netAmount"
                                :data-vv-as="creditNoteFormLabel.netAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'required|mask_decimal:2|mask_max_value:9999999999999.99|mask_min_value:0.01'"
                                @blur="calculateAmount()"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                               <v-autocomplete
                                :items="currencies"
                                v-model="creditNoteForm.netLocalAmountCurr"
                                :label="creditNoteFormLabel.netLocalAmountCurr"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.netLocalAmountCurr"
                                :data-vv-as="creditNoteFormLabel.netLocalAmountCurr"
                                :error-messages="errors.collect('receipcreditNoteFormsForm.netLocalAmountCurr')"
                                disabled
                              />
                            </v-flex>
                            <v-flex md1 xs12>
                              <v-checkbox
                                color="primary"
                                :label="creditNoteFormLabel.netAmountLocalAE"
                                v-model="creditNoteForm.netAmountLocalAE"
                                :disabled="matchBaseCurr"
                                @change="calculateAmount()"
                              ></v-checkbox>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                ref="netLocalAmount"
                                v-model="creditNoteForm.netLocalAmount"
                                :label="creditNoteFormLabel.netLocalAmount"
                                :disabled="isNetLocAmt || matchBaseCurr"
                                :error-messages="errors.collect('creditNoteForm.netLocalAmount')"
                                data-vv-name="creditNoteForm.netLocalAmount"
                                :data-vv-as="creditNoteFormLabel.netLocalAmount"
                                v-num-mask="{ negative: true, intScale: 13, decScale: 2 }"
                                v-validate="'mask_decimal:2|mask_max_value:9999999999999.99'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.createdBy }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.createdBy + ' on ' + creditNoteForm.createdDate }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-if="isNew">
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ createdName + ' on ' + nowDT }}</div>
                            </v-flex>
                            <v-flex md6 xs12 sm6 lg6 v-else>
                              <v-subheader class="queryLabel">{{ creditNoteFormLabel.modifiedBy }}</v-subheader>
                              <div class="queryValue">{{ creditNoteForm.modifiedBy + ' on ' + creditNoteForm.modifiedDate }}</div>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
              <v-tab-item transition="fade-transition" reverse-transition="fade-transition" key="optional" eager>
                <form data-vv-scope="creditNoteOptionalForm">
                  <v-flex xs12>
                    <v-card>
                      <v-card-text>
                        <v-container fluid grid-list-lg>
                          <v-layout row wrap>
                            <v-flex xs12>
                              <div class="header-padding body-2">Document Details</div>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="printDocOpts"
                                v-model="creditNoteForm.printDocument"
                                :label="creditNoteFormLabel.printDocument"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.printDocument"
                                :data-vv-as="creditNoteFormLabel.printDocument"
                                :error-messages="errors.collect('creditNoteForm.printDocument')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md6 xs12>
                              <v-autocomplete
                                :items="addressToOpts"
                                v-model="creditNoteForm.addressTo"
                                :label="creditNoteFormLabel.addressTo"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.addressTo"
                                :data-vv-as="creditNoteFormLabel.addressTo"
                                :error-messages="errors.collect('creditNoteForm.addressTo')"
                                @change="promptRemoveNameAddr = true"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="creditNoteForm.policyNo"
                                :label="creditNoteFormLabel.policyNo"
                                :error-messages="errors.collect('creditNoteForm.policyNo')"
                                data-vv-name="creditNoteForm.policyNo"
                                :data-vv-as="creditNoteFormLabel.policyNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showAcctPolicyHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="creditNoteForm.companyName"
                                :label="creditNoteFormLabel.companyName"
                                :error-messages="errors.collect('creditNoteForm.companyName')"
                                data-vv-name="creditNoteForm.companyName"
                                :data-vv-as="creditNoteFormLabel.companyName"
                                v-validate="'entry|max:100|sanction:' + sanctionName1Error"
                                @change="valSanction(creditNoteForm.companyName, '', 'sanctionName1Error')"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.docAddress1"
                                :label="creditNoteFormLabel.docAddress1"
                                :error-messages="errors.collect('creditNoteForm.docAddress1')"
                                data-vv-name="creditNoteForm.docAddress1"
                                :data-vv-as="creditNoteFormLabel.docAddress1"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.docAddress2"
                                :label="creditNoteFormLabel.docAddress2"
                                :error-messages="errors.collect('creditNoteForm.docAddress2')"
                                data-vv-name="creditNoteForm.docAddress2"
                                :data-vv-as="creditNoteFormLabel.docAddress2"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.docAddress3"
                                :label="creditNoteFormLabel.docAddress3"
                                :error-messages="errors.collect('creditNoteForm.docAddress3')"
                                data-vv-name="creditNoteForm.docAddress3"
                                :data-vv-as="creditNoteFormLabel.docAddress3"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.docAddress4"
                                :label="creditNoteFormLabel.docAddress4"
                                :error-messages="errors.collect('creditNoteForm.docAddress4')"
                                data-vv-name="creditNoteForm.docAddress4"
                                :data-vv-as="creditNoteFormLabel.docAddress4"
                                v-validate="'max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-text-field
                                v-model="creditNoteForm.postalCode"
                                :label="creditNoteFormLabel.postalCode"
                                :error-messages="errors.collect('creditNoteForm.postalCode')"
                                data-vv-name="creditNoteForm.postalCode"
                                :data-vv-as="creditNoteFormLabel.postalCode"
                                v-validate="'entry|numeric|max:8'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.details"
                                :label="creditNoteFormLabel.details"
                                :error-messages="errors.collect('creditNoteForm.details')"
                                data-vv-name="creditNoteForm.details"
                                :data-vv-as="creditNoteFormLabel.details"
                                v-validate="'entry|max:120'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.statementRef"
                                :label="creditNoteFormLabel.statementRef"
                                :error-messages="errors.collect('creditNoteForm.statementRef')"
                                data-vv-name="creditNoteForm.statementRef"
                                :data-vv-as="creditNoteFormLabel.statementRef"
                                v-validate="'entry|max:200'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex xs12>
                              <div class="header-padding body-2">Other Details</div>
                            </v-flex>
                            <v-flex md7 xs12>
                              <v-autocomplete
                                :items="departments"
                                v-model="creditNoteForm.department"
                                :label="creditNoteFormLabel.department"
                                item-text="label"
                                item-value="value"
                                data-vv-name="creditNoteForm.department"
                                :data-vv-as="creditNoteFormLabel.department"
                                v-validate="deptValidation"
                                :error-messages="errors.collect('creditNoteForm.department')"
                              ></v-autocomplete>
                            </v-flex>
                            <v-flex md12 xs12>
                              <v-text-field
                                v-model="creditNoteForm.insuredName"
                                :label="creditNoteFormLabel.insuredName"
                                :error-messages="errors.collect('creditNoteForm.insuredName')"
                                data-vv-name="creditNoteForm.insuredName"
                                :data-vv-as="creditNoteFormLabel.insuredName"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="creditNoteForm.claimNo"
                                :label="creditNoteFormLabel.claimNo"
                                :error-messages="errors.collect('creditNoteForm.claimNo')"
                                data-vv-name="creditNoteForm.claimNo"
                                :data-vv-as="creditNoteFormLabel.claimNo"
                                v-validate="'entry|max:60'"
                              >
                                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                                  <v-icon color="info" @click="showClmHelpList = true" v-text="'mdi-magnify'"></v-icon>
                                </v-slide-x-reverse-transition>
                              </v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="creditNoteForm.gstRegNo"
                                :label="creditNoteFormLabel.gstRegNo"
                                :error-messages="errors.collect('creditNoteForm.gstRegNo')"
                                data-vv-name="creditNoteForm.gstRegNo"
                                :data-vv-as="creditNoteFormLabel.gstRegNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                            <v-flex md4 xs12>
                              <v-text-field
                                v-model="creditNoteForm.taxInvoiceNo"
                                :label="creditNoteFormLabel.taxInvoiceNo"
                                :error-messages="errors.collect('creditNoteForm.taxInvoiceNo')"
                                data-vv-name="creditNoteForm.taxInvoiceNo"
                                :data-vv-as="creditNoteFormLabel.taxInvoiceNo"
                                v-validate="'entry|max:60'"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                    </v-card>
                  </v-flex>
                </form>
              </v-tab-item>
            </v-tabs-items>
            <v-card-actions>
              <v-btn color="error" dark @click.prevent="doCancel">
                {{ actionLabel.cancel }}
                <v-icon dark right>mdi-exit-to-app</v-icon>
              </v-btn>
              <v-btn color="secondary" dark @click="showMatchLater = true">
                {{ actionLabel.matchLater }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSaveCreditNote('CREATE_MATCH_NOW')" :loading="submitting">
                {{ actionLabel.matchNow }}
                <v-icon dark right>mdi-content-copy</v-icon>
              </v-btn>
              <v-btn color="info" dark @click.prevent="doSaveCreditNote('CREATE_SAVE_REVIEW')" :loading="submitting">
                {{ actionLabel.saveAndReview }}
                <v-icon dark right>mdi-content-save</v-icon>
              </v-btn>
              <v-btn color="primary" dark @click.prevent="doSaveCreditNote('CREATE_SAVE_POST')" :loading="submitting">
                {{ actionLabel.saveAndPost }}
                <v-icon dark right>mdi-arrow-right-bold-box</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="this.creditNoteData.tranMode === 'R'">
          <!-- CBO Added: Oct-05-2020 Comments -->
          <v-container fluid grid-list-sm>
            <v-layout row wrap>
              <v-flex lg12 xs12 order-lg1 order-xs2>
                <common-comments :commentRefNo="this.commentRefNo" :commentTranType="this.commentTranType"></common-comments>
              </v-flex>
            </v-layout>
          </v-container>
        </v-flex>
      </v-layout>
      <v-dialog v-model="showAcctNoHelpList" width="1280px">
        <acct-no-help-list
          @close="showAcctNoHelpList = false"
          @assign-acct-info="assignAcctInfo"
          :boolRefresh="showAcctNoHelpList"
        ></acct-no-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctSufHelpList" width="1280px">
        <acct-suf-help-list
          :acctNoSfxApplnInt="this.acctNoSfxApplnInt"
          @close="showAcctSufHelpList = false"
          @assign-acct-suf-info="assignAcctSufInfo"
        ></acct-suf-help-list>
      </v-dialog>

      <v-dialog v-model="showFundHelpList" width="1280px">
        <fund-help-list @close="showFundHelpList = false" @assign-fund="assignFund"></fund-help-list>
      </v-dialog>

      <v-dialog v-model="showCurrencyHelpList" width="1280px">
        <currency-help-list @close="showCurrencyHelpList = false" @assign-currency-info="assignCurrencyInfo"></currency-help-list>
      </v-dialog>

      <v-dialog v-model="showAcctPolicyHelpList" width="1280px">
        <acct-policy-help-list
          :accountNo="creditNoteForm.accountNo"
          :extraTranGrp="2"
          :boolPolRefresh="showAcctPolicyHelpList"
          @close="showAcctPolicyHelpList = false"
          @assign-policy-info="assignPolicyInfo"
        ></acct-policy-help-list>
      </v-dialog>

      <v-dialog v-model="showClmHelpList" width="1280px">
        <claim-help-list
          @close="showClmHelpList = false"
          @assign-claim-no="assignClaimNo"
          :boolRefresh="showClmHelpList"
          :accountNo="creditNoteForm.accountNo"
        ></claim-help-list>
      </v-dialog>

      <v-dialog v-model="processingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Processing...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <v-dialog v-model="loadingFlag" persistent width="300">
        <v-card color="primary" dark>
          <v-card-text>
            Loading...
            <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
      <warning v-model="promptMsg" :label="errMsg" :showAcceptBtn="isWarning" @ok="acceptInterWarn = true"/>
      <v-dialog v-model="showErrorDialog" width="800px">
        <v-card>
          <v-card-title primary-title>
            <div>
              <div class="headline">System Information</div>
              <span class="grey--text">An error occurred when creating Credit Note.</span>
            </div>
          </v-card-title>
          <v-card-text>
            <div v-if="messages.length > 0" class="pb-3">
              <v-subheader>Error Details:</v-subheader>
              <ul class="showErrorMsgs">
                <li v-for="(error, index) in messages" :key="index">
                  {{ error.message }}
                </li>
              </ul>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="red darken-1" text @click.native="showErrorDialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!--LYT Added: 2020-08-27  Sanction Partial Matched Names List -->
      <v-dialog v-model="showSanctionDialog" width="1280px">
        <sanction-partial-match-list :sanctionItems="sanctionPartialMatchItems" @close="showSanctionDialog = false"></sanction-partial-match-list>
      </v-dialog>
      <v-dialog v-model="showMatchLater" width="680px">
        <match-later
          :multiFundSfxCurr="miscacctparams.multiFundSfxCurr"
          :tranType="creditNoteForm.transactionType"
          :curr="creditNoteForm.amountCurr"
          :acctNo="creditNoteForm.accountNo"
          :fund="creditNoteForm.fund"
          :acctNoSfx="creditNoteForm.accountNoSuffix"
          :polNo="creditNoteForm.policyNo"
          :boolRefresh="showMatchLater"
          @close="showMatchLater = false"
          @assign-match-later-info="assignMatchLaterInfo"
        ></match-later>
      </v-dialog>

      <prompt-leave
        v-if="showPromptLeave"
        title="Credit Note"
        :tranMode="this.creditNoteData.tranMode"
        v-model="promptLeave"
        @exit="doExit"
        @saveAndExit="doSaveAndExit"
      ></prompt-leave>
      <confirm v-model="promptRemoveNameAddr" @ok="doRemoveNameAddr">
        {{ promptRemoveNameAddrMsg }}
      </confirm>
    </v-container>
  </page>
</template>

<script>
import routeMixin from '@/mixins/route'
import MessageMixin from '@/mixins/message'
import { creditNoteAjaxMixin } from '@/mixins/accounting/creditNote/creditNoteAjaxMixin'
import { creditNoteViewMixin } from '@/mixins/accounting/creditNote/creditNoteViewMixin'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import AcctNoHelpList from '@/components/core/common/dialog/AcctNoHelpList'
import AcctSufHelpList from '@/components/core/common/dialog/AcctSufHelpList'
import CurrencyHelpList from '@/components/core/common/dialog/CurrencyHelpList'
import AcctPolicyHelpList from '@/components/core/common/dialog/AcctPolicyHelpList'
import ClaimHelpList from '@/components/core/common/dialog/ClaimHelpList'
import FundHelpList from '@/components/core/common/dialog/FundHelpList'
import { promptOnExitMixin } from '@/mixins/common/promptOnExitMixin'
import PromptLeave from '@/components/core/common/prompt/PromptLeave'
import { formatPrice } from '@/utils/index'
import { removeFormatNumber } from '@/utils/number'
import { parseISO } from 'date-fns'
import { formatDisplayDate, formatDisplayDateTime2, removeTime } from '@/utils/date'
import SanctionPartialMatchList from '@/components/core/common/dialog/SanctionPartialMatchList'
import MatchLater from '../dialog/MatchLater'
import CommonComments from '@/components/core/accounting/CommonComments'
import isAfter from 'date-fns/isAfter'

export default {
  data() {
    return {
      tabNav: 0,
      acctNoSfxApplnInt: '60',
      actionLabel: {
        cancel: 'Cancel',
        saveAndReview: 'Save & Review',
        saveAndPost: 'Save & Post',
        matchNow: 'Match Now',
        matchLater: 'Match Later'
      },
      validStatus: {
        mandatory: true,
        optional: true
      },
      loading: false,
      loadingFlag: false,
      processingFlag: false,
      showErrorDialog: false,
      submitting: false,
      showPromptLeave: true,
      accounts: [],
      showAcctNoHelpList: false,
      accountdata: {},
      acctnosuffixes60: [],
      showAcctSufHelpList: false,
      amountcurrencies: [],
      showCurrencyHelpList: false,
      amountcurrencydata: {},
      showAcctPolicyHelpList: false,
      departments: [],
      miscacctparams: [],
      currencies: [],
      funds: [],
      branches: [],
      showClmHelpList: false,
      showFundHelpList: false,
      isMandatory: true,
      isOptional: false,
      trandaterange: {},
      gstStatuses: [],
      gstrate: '0.00',
      baseCurrency: '',
      showMatchLater: false,
      promptRemoveNameAddr: false,
      promptRemoveNameAddrMsg: 'Do you want to remove Name, Address(1-4), Postal Code?'
    }
  },
  watch: {
    displayErrorDialog: {
      handler: function (messages) {
        if (messages && messages.length > 0) {
          this.showErrorDialog = true
        }
      },
      deep: true
    },
    'tDateRange.effDate': function () {
      if (this.tDateRange.effDate !== '' && this.creditNoteData.tranMode === '') {
        this.loading = true
        this.getCommonData('gstrate', this.creditNoteForm.gstStatus, formatDisplayDateTime2(this.creditNoteForm.transactionDate)).then(result => {
          if (result) {
            this.loading = false
          }
        })
      }
    },
    'creditNoteForm.amountCurr': function () {
      if (this.creditNoteForm.amountCurr && this.creditNoteForm.transactionDate) {
        this.getCommonData('currencyrate', this.creditNoteForm.amountCurr, formatDisplayDateTime2(this.creditNoteForm.transactionDate))
      }
    },
    'creditNoteForm.transactionDate': function () {
      if (this.creditNoteForm.amountCurr && this.creditNoteForm.transactionDate) {
        this.getCommonData('currencyrate', this.creditNoteForm.amountCurr, formatDisplayDateTime2(this.creditNoteForm.transactionDate))
      }
    }
  },
  computed: {
    doValidateTranDate() {
      const minDate = this.tDateRange.effDate
      const today = this.tDateRange.expDate
      return 'required|valMinTranDate:' + minDate + '|valMaxTranDate:' + today
    },
    creditNoteData() {
      return this.$store.state.creditNote.creditNoteData
    },
    displayErrorDialog() {
      return this.messages
    },
    token() {
      return this.$store.state.token
    },
    isDisableddocumentNo: function () {
      return this.creditNoteForm.docAE
    },
    isBlankGSTIO: function () {
      return this.creditNoteForm.gstIO === 'B'
    },
    isGstAmtAE: function () {
      if (this.creditNoteForm.gstIO === 'B') {
        return true
      } else {
        return false
      }
    },
    isGstAmt: function () {
      return this.creditNoteForm.gstAmountAE
    },
    isNetLocAmt: function () {
      return this.creditNoteForm.netAmountLocalAE
    },
    docNoValidation() {
      return 'entry|documentNo:' + this.creditNoteForm.isExistDocNo
    },
    deptValidation() {
      if (this.miscacctparams.deptMand) {
        return 'required'
      } else {
        return ''
      }
    },
    tDateRange() {
      return this.trandaterange
    },
    matchBaseCurr: function () {
      if (this.creditNoteForm.amountCurr !== null && this.creditNoteForm.amountCurr === this.baseCurrency) {
        return true
      } else {
        return false
      }
    },
    apiURI() {
      return this.$store.state.creditNote.menu
    },
    commentRefNo() {
      const data = this.$store.state.creditNote.creditNoteData
      return data.accountNo + data.documentNo + data.fund + data.suffix + data.branch + data.type
    },
    commentTranType() {
      return this.$store.state.creditNote.creditNoteData.type
    },
    isNew() {
      return !(this.creditNoteData.tranMode === 'Q' || this.creditNoteData.tranMode === 'R')
    }
  },
  methods: {
    async doInit() {
      this.loadingFlag = true
      await Promise.all([this.$store.dispatch('commonsInit')])
      await Promise.all([this.$store.dispatch('creditNoteInit')])
      this.getBaseCurr(this.creditNoteForm)
      this.getCommonData('trandaterange', '005')
      this.getCommonData('miscacctparams').then(() => {
        this.creditNoteForm.printDocument = this.miscacctparams.defIlncr
      })
      this.creditNoteTranMode()
      this.fetchDepartment()
      this.fetchBranch()
      this.fetchFund()
      this.fetchAmountCurrency()
      this.fetchAcctNoSfx60()
      this.fetchGstStatus()
      this.fetchCurrency()
      this.fetchAccount().then(() => {
        this.loadingFlag = false
      })
    },
    async creditNoteTranMode() {
      if (this.creditNoteData.tranMode === 'R') {
        await Promise.all([this.performReview()])
      } else {
        this.creditNoteForm.branch = this.token.userBranch
        this.creditNoteForm.transactionDate = new Date()
        this.creditNoteForm.transactionType = 'B'
        this.creditNoteForm.gstIO = 'B'
        this.creditNoteForm.gstStatus = 'N'
        this.creditNoteForm.addressTo = 'A'
      }
    },
    currencyChange() {
      this.creditNoteForm.gstAmountCurr = this.creditNoteForm.amountCurr
      this.creditNoteForm.netAmountCurr = this.creditNoteForm.amountCurr
    },
    changeGstIO(gstIO) {
      this.creditNoteForm.gstIO = gstIO
      if (this.creditNoteForm.gstIO === 'B') {
        this.creditNoteForm.gstStatus = 'B'
        this.creditNoteForm.gstAmount = (0.0).toFixed(2)
        this.creditNoteForm.gstRate = (0.0).toFixed(2)
      } else {
        this.creditNoteForm.gstStatus = 'M'
        this.getCommonData('gstrate', this.creditNoteForm.gstStatus, formatDisplayDateTime2(this.creditNoteForm.transactionDate))
        // this.creditNoteForm.gstRate = (7.00).toFixed(2)
      }
      this.calculateAmount()
    },
    changeGstRate(gstStatus) {
      this.getCommonData('gstrate', gstStatus, formatDisplayDateTime2(this.creditNoteForm.transactionDate))
    },
    setAmount() {
      this.$refs.amount.$el.cleave.setRawValue(this.creditNoteForm.amount)
      this.creditNoteForm.amount = formatPrice(this.$refs.amount.$el.cleave.getRawValue())
      this.$refs.gstAmount.$el.cleave.setRawValue(this.creditNoteForm.gstAmount)
      this.creditNoteForm.gstAmount = formatPrice(this.$refs.gstAmount.$el.cleave.getRawValue())
      this.$refs.netLocalAmount.$el.cleave.setRawValue(this.creditNoteForm.netLocalAmount)
      this.creditNoteForm.netLocalAmount = formatPrice(this.$refs.netLocalAmount.$el.cleave.getRawValue())
    },
    checkDocNo() {
      this.isDocNoExist(this.creditNoteForm)
    },
    doMandatory(tabId) {
      if (this.isMandatory === false) {
        this.$validator.validateAll('creditNoteOptionalForm').then((result) => {
          if (result) {
            this.isMandatory = true
            this.isOptional = false
            this.validStatus.optional = true
            this.validStatus.mandatory = true
            this.tabNav = tabId
          } else {
            if (this.isMandatory === true && this.isOptional === false) {
              this.validStatus.optional = true
              this.tabNav = 0
            } else {
              this.validStatus.optional = false
              this.tabNav = 1
            }
          }
        })
      }
    },
    doOptionalA() {
      if (this.isMandatory === false && this.isOptional === true) {
        this.validStatus.mandatory = true
        this.tabNav = 1
      } else {
        this.validStatus.mandatory = false
        this.tabNav = 0
      }
    },
    doOptional(tabId) {
      if (this.isOptional === false) {
        this.$validator.validateAll('creditNoteMandatoryForm').then((result) => {
          if (result) {
            this.ValidateTranDateRange(this.creditNoteForm.transactionDate, '005').then((result) => {
              if (result) {
                if (this.creditNoteData.tranMode !== 'R') {
                  this.validateIntermediary(this.creditNoteForm.transactionDate, this.creditNoteForm.accountNo).then(() => {
                    if (this.promptMsg === false || this.acceptInterWarn === true) {
                      this.isMandatory = false
                      this.isOptional = true
                      this.validStatus.mandatory = true
                      this.validStatus.optional = true
                      this.tabNav = tabId
                    } else {
                      this.doOptionalA()
                    }
                  })
                } else {
                  this.isMandatory = false
                  this.isOptional = true
                  this.validStatus.mandatory = true
                  this.validStatus.optional = true
                  this.tabNav = tabId
                }
              } else {
                this.doOptionalA()
              }
            })
          } else {
            this.doOptionalA()
            this.promptFieldCheck()
          }
        })
      }
    },
    formatDate(date) {
      return formatDisplayDate(date)
    },
    parseDateISO(value) {
      if (value) {
        return parseISO(value)
      }
    },
    doSaveCreditNote(actionName) {
      if (this.creditNoteData.tranMode === 'R') {
        if (actionName === 'CREATE_SAVE_REVIEW') {
          actionName = 'UPDATE_SAVE_REVIEW'
        } else if (actionName === 'CREATE_SAVE_POST') {
          actionName = 'UPDATE_SAVE_POST'
        } else if (actionName === 'CREATE_MATCH_NOW') {
          actionName = 'UPDATE_MATCH_NOW'
        } else if (actionName === 'CREATE_MATCH_LATER') {
          actionName = 'UPDATE_MATCH_LATER'
        }
      }
      this.processingFlag = true
      this.$validator.validateAll('creditNoteMandatoryForm').then((result) => {
        if (result) {
          this.ValidateTranDateRange(this.creditNoteForm.transactionDate, '005').then((result) => {
            if (result) {
              if (this.creditNoteData.tranMode !== 'R') {
                this.validateIntermediary(this.creditNoteForm.transactionDate, this.creditNoteForm.accountNo).then((result) => {
                  if (this.promptMsg === false || this.acceptInterWarn === true) {
                    this.isMandatory = false
                    this.isOptional = true
                    this.$validator.validateAll('creditNoteOptionalForm').then((result) => {
                      if (result) {
                        this.isMandatory = true
                        this.isOptional = false
                        this.processingFlag = true
                        this.creditNoteForm.actionName = actionName
                        this.performSave()
                      } else {
                        this.validStatus.optional = false
                        this.processingFlag = false
                        this.tabNav = 1
                      }
                    })
                  } else {
                    this.validStatus.optional = false
                    this.processingFlag = false
                    this.tabNav = 0
                  }
                })
              } else {
                this.isMandatory = false
                this.isOptional = true
                this.$validator.validateAll('creditNoteOptionalForm').then((result) => {
                  if (result) {
                    this.isMandatory = true
                    this.isOptional = false
                    this.processingFlag = true
                    this.creditNoteForm.actionName = actionName
                    this.performSave()
                  } else {
                    this.validStatus.optional = false
                    this.processingFlag = false
                    this.tabNav = 1
                  }
                })
              }
            } else {
              this.validStatus.optional = false
              this.processingFlag = false
              this.tabNav = 0
            }
          })
        } else {
          this.validStatus.mandatory = false
          this.processingFlag = false
          this.tabNav = 0
          this.promptFieldCheck()
        }
      })
    },
    doCancel() {
      this.$router.push({ name: 'creditNote' }).catch(() => {})
    },
    assignAcctInfo(data) {
      this.creditNoteForm.accountNo = data.inter
      if (this.creditNoteForm.addressTo === 'A') {
        this.creditNoteForm.gstRegNo = data.gstRegNo
        this.creditNoteForm.companyName = data.name
        this.creditNoteForm.docAddress1 = data.address1
        this.creditNoteForm.docAddress2 = data.address2
        this.creditNoteForm.docAddress3 = data.address3
        this.creditNoteForm.docAddress4 = data.address4
        this.creditNoteForm.postalCode = data.postalCode
      }
      this.showAcctNoHelpList = false
    },
    assignAcctSufInfo(data) {
      this.creditNoteForm.accountNoSuffix = data.acctNoSfx
      this.showAcctSufHelpList = false
    },
    assignCurrencyInfo(data) {
      this.creditNoteForm.amountCurr = data.curr
      this.creditNoteForm.gstAmountCurr = data.curr
      this.creditNoteForm.netAmountCurr = data.curr
      this.creditNoteForm.amountCurrRate = data.currRate
      this.showCurrencyHelpList = false
      this.calculateAmount()
    },
    assignFund(fund) {
      this.creditNoteForm.fund = fund
      this.showFundHelpList = false
    },
    assignPolicyInfo(data) {
      this.creditNoteForm.policyNo = data.policyNo + '-' + data.renCnt + '-' + data.endtCnt
      this.creditNoteForm.insuredName = data.insuredName
      this.creditNoteForm.insdRefNo = data.insdRefNo
      if (this.creditNoteForm.addressTo === 'I') {
        this.creditNoteForm.companyName = data.fullName
        this.creditNoteForm.docAddress1 = data.address1
        this.creditNoteForm.docAddress2 = data.address2
        this.creditNoteForm.docAddress3 = data.address3
        this.creditNoteForm.docAddress4 = data.address4
        this.creditNoteForm.postalCode = data.postalCode
      }
      this.showAcctPolicyHelpList = false
    },
    assignGSTRate(data) {
      this.creditNoteForm.gstRate = formatPrice(data)
      this.calculateAmount()
    },
    doRemoveNameAddr() {
      this.creditNoteForm.companyName = ''
      this.creditNoteForm.docAddress1 = ''
      this.creditNoteForm.docAddress2 = ''
      this.creditNoteForm.docAddress3 = ''
      this.creditNoteForm.docAddress4 = ''
      this.creditNoteForm.postalCode = ''
    },
    assignCurrRate(currRate) {
      this.creditNoteForm.amountCurrRate = currRate
      this.creditNoteForm.gstAmountCurr = this.creditNoteForm.amountCurr
      this.creditNoteForm.netAmountCurr = this.creditNoteForm.amountCurr
      this.calculateAmount()
    },
    async getAcctInfo(acctNo) {
      this.getCommonData('accountdata', acctNo)
    },
    assignClaimNo(claimNo) {
      this.creditNoteForm.claimNo = claimNo
      this.showClmHelpList = false
    },
    assignBaseCurr(data) {
      this.baseCurrency = data[0]
      if (this.creditNoteData.tranMode === '' && this.creditNoteForm.amountCurr === null) {
        this.creditNoteForm.amountCurr = data[0]
      }
    },
    calculateAmount() {
      if (this.baseCurrency !== '' && this.baseCurrency === this.creditNoteForm.amountCurr) {
        this.creditNoteForm.netAmountLocalAE = true
      }

      if (this.creditNoteForm.gstAmountAE) {
        this.creditNoteForm.gstAmount = formatPrice((removeFormatNumber(this.creditNoteForm.amount) * this.creditNoteForm.gstRate) / 100)
      }

      if (this.creditNoteForm.gstIO === 'B') {
        this.creditNoteForm.netAmount = formatPrice(Number(removeFormatNumber(this.creditNoteForm.amount)))
      } else if (this.creditNoteForm.gstIO === 'I') {
        this.creditNoteForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.creditNoteForm.amount)) + Number(removeFormatNumber(this.creditNoteForm.gstAmount))
        )
      } else if (this.creditNoteForm.gstIO === 'O') {
        this.creditNoteForm.netAmount = formatPrice(
          Number(removeFormatNumber(this.creditNoteForm.amount)) + Number(removeFormatNumber(this.creditNoteForm.gstAmount))
        )
      }
      /* Since netLocalAmountCurr is set same with amountCurr then the netLocalAmountCurrRate is same with amountCurrRate */
      if (this.creditNoteForm.netAmountLocalAE) {
        this.creditNoteForm.netLocalAmount = formatPrice(
          Number(removeFormatNumber(this.creditNoteForm.netAmount)) * this.creditNoteForm.amountCurrRate
        )
      }
      this.setAmount()
    },
    assignMatchLaterInfo(data) {
      this.creditNoteForm.bmAcctNo = data.bmAcctNo
      this.creditNoteForm.bmAcctNoSfx = data.bmAcctNoSfx
      this.creditNoteForm.bmBrn = data.bmBrn
      this.creditNoteForm.bmFund = data.bmFund
      this.creditNoteForm.bmTranType = data.bmTranType
      this.creditNoteForm.bmDocNo = data.bmDocNo
      this.showMatchLater = false
      this.doSaveCreditNote('CREATE_MATCH_LATER')
    }
  },
  created() {
    this.$validator.extend('documentNo', {
      getMessage(field, args) {
        return 'This document no. is exist.'
      },
      validate(value, args) {
        if (args === void 0) args = []
        var isdocNoExist = args[0]
        if (isdocNoExist === 'true') {
          return false
        } else {
          return true
        }
      }
    })
    this.$validator.extend('valMaxTranDate', {
      getMessage(field, args) {
        return 'This date cannot be greater than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let maxDate = args[0]
        if (value) {
          return !isAfter(removeTime(value), removeTime(maxDate))
        } else return true
      }
    })
    this.$validator.extend('valMinTranDate', {
      getMessage(field, args) {
        return 'This date cannot be lesser than the date range ' + formatDisplayDate(args[0])
      },
      validate(value, args) {
        let minDate = args[0]
        if (value) {
          return !isAfter(removeTime(minDate), removeTime(value))
        } else return true
      }
    })
  },
  mounted() {
    this.doInit()
  },
  mixins: [routeMixin, MessageMixin, creditNoteAjaxMixin, creditNoteViewMixin, commonAjaxMixin, promptOnExitMixin],
  components: {
    AcctNoHelpList,
    AcctSufHelpList,
    CurrencyHelpList,
    AcctPolicyHelpList,
    ClaimHelpList,
    FundHelpList,
    PromptLeave,
    SanctionPartialMatchList,
    MatchLater,
    CommonComments
  }
}
</script>
<style lang="scss">
@import '../../../../assets/scss/accounting.scss';
</style>
